import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from 'react-redux';

import {
  Modal,
  Image
} from '@lockerpm/design';

import images from "../../assets/images";
import common from "../../utils/common";
import global from "../../config/global";

import dayjs from 'dayjs'

const SaleBlackFridayModal = () => {
  const locale = useSelector((state) => state.system.locale);
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const isLifeTimeUser = common.isLifeTimeUser();
    const isEnterpriseMember = common.isEnterpriseMember();
    const startDay = dayjs('2024-11-25T00:00:00').unix();
    const endDay = dayjs('2024-11-30T23:59:59').unix();
    const now = dayjs().unix();
    const isLimited = (now < startDay) || (now > endDay);
    if (!isLimited && !isLifeTimeUser && !isEnterpriseMember) {
      const currentDay = common.convertDateTime(now, 'YYYY-MM-DD');
      const storageCurrentDay = common.getSaleBlackFridayDay();
      if (!storageCurrentDay || (currentDay !== storageCurrentDay)) {
        setVisible(true);
      }
    }
  }, [])

  const onCancel = () => {
    const now = dayjs().unix();
    const currentDay = common.convertDateTime(now, 'YYYY-MM-DD');
    common.setSaleBlackFridayDay(currentDay);
    setVisible(false)
  }

  const saleImage = useMemo(() => {
    if (locale === global.constants.LANGUAGE.VI) {
      return images.SaleViImg
    }
    return images.SaleEnImg
  }, [locale])

  return (
    <Modal
      open={visible}
      onCancel={() => onCancel()}
      width={640}
      footer={false}
      className="sale-black-friday"
    >
      <div
        className="cursor-pointer"
        onClick={() => {
          const localeLinks = global?.urls?.DOC_LINKS[locale] || global?.urls?.DOC_LINKS.en
          common.openNewTab(localeLinks?.SALE_BLACK_FRIDAY);
          onCancel();
        }}
      >
        <Image
          src={saleImage}
          preview={false}
        />
      </div>
    </Modal>
  );
}

export default SaleBlackFridayModal;